module.exports = __webpack_public_path__ + "media/images/flags/ST-7b76da88f5521890f7395eaea41f5b70.svg";